import { MenuItem, Category, RestaurantInfo, FryFlavor, ShakeItem } from '../types';

export const restaurantInfo: RestaurantInfo = {
  name: "Royale with Cheese",
  tagline: "Detroit's #1 Burger Destination",
  address: "4163 CASS AVE, DETROIT, MI 48201",
  phone: "+1 313-315-3014",
  hours: {
    "Mon-Thu": "11am-10pm",
    "Fri-Sat": "11am-11pm",
    "Sun": "12pm-9pm"
  },
  rating: 4.2,
  totalRatings: 100
};

export const signatureBurgers: MenuItem[] = [
  {
    id: "havana-breakfast",
    name: "Havana Breakfast Burger",
    description: "The ultimate breakfast experience! Premium beef patty topped with crispy turkey bacon, perfectly fried egg, our signature Royale fries, rich cheese fondue, smoky chipotle ketchup, and house-made Royale sauce. Perfect for breakfast, lunch, or dinner.",
    price: 13.00,
    image: "/images/havana_breakfast_burger_optimized.jpg",
    category: "signature-burgers",
    tags: ["BREAKFAST FEEL"],
    ingredients: ["Premium beef patty", "Crispy turkey bacon", "Fresh fried egg", "Signature Royale fries", "Rich cheese fondue", "Smoky chipotle ketchup", "House-made Royale sauce", "Artisan bun"],
    allergens: ["Contains Gluten", "Contains Dairy", "Contains Eggs"]
  },
  {
    id: "kruncher-spicy",
    name: "Kruncher Spicy Burger",
    description: "Feel the crunch and heat! Premium beef patty topped with crispy jalapeño kruncher chips, rich roasted pepper chili queso, fresh southwestern roasted corn, and zesty Cajun aioli. Perfect mild-medium heat level for spice lovers seeking satisfaction.",
    price: 13.00,
    image: "/images/kruncher_spicy_burger_optimized.jpg",
    category: "signature-burgers",
    tags: ["MILD-MEDIUM HEAT"],
    ingredients: ["Premium beef patty", "Crispy jalapeño kruncher chips", "Roasted pepper chili queso", "Southwestern roasted corn", "Zesty Cajun aioli", "Fresh lettuce", "Artisan bun"],
    allergens: ["Contains Gluten", "Contains Dairy", "Contains Spices"]
  },
  {
    id: "mia-wallace",
    name: "Mia Wallace",
    description: "BBQ twist! Beef patty, mesquite BBQ chips, fire-roasted poblanos & corn, house-smoked candied turkey bacon, honey-ancho BBQ aioli, American-Swiss cheese",
    price: 13.00,
    image: "/images/mia_wallace_bbq_burger_new.jpg",
    category: "signature-burgers",
    tags: ["BBQ SPECIALTY"],
    ingredients: ["Premium beef patty", "Mesquite BBQ chips", "Fire-roasted poblanos", "Roasted corn", "House-smoked candied turkey bacon", "Honey-ancho BBQ aioli", "American-Swiss cheese", "Artisan bun"],
    allergens: ["Contains Gluten", "Contains Dairy", "Contains Pork"]
  },
  {
    id: "just-a-burger",
    name: "Just A Burger",
    description: "For the purists. Premium beef patty with rich cheese fondue, crisp artisan romaine lettuce, fresh red onions, authentic Nablus pickles, seasonal tomatoes, classic ketchup and creamy mayonnaise",
    price: 10.00,
    image: "/images/just_a_burger_optimized.jpg",
    category: "signature-burgers",
    tags: ["CLASSIC"]
  },
  {
    id: "beirut",
    name: "Beirut",
    description: "Mediterranean flavors! Creamy cole slaw, fries, Nablus pickles, seasonal tomatoes, cheese fondue, topped with ketchup",
    price: 12.00,
    image: "/images/beirut_mediterranean_burger.jpg",
    category: "signature-burgers",
    tags: ["MEDITERRANEAN"]
  },
  {
    id: "big-kahuna",
    name: "Big Kahuna",
    description: "The ultimate indulgence! Double premium beef patties with caramelized mushrooms, flame-roasted onions and peppers, signature Royale fries, classic ketchup, creamy mayonnaise, and melted American-Swiss cheese. A true burger lover's dream.",
    price: 14.00,
    image: "/images/image-branding/Big Kahuna.png",
    category: "signature-burgers",
    tags: ["DOUBLE PATTY", "GOURMET"],
    ingredients: ["Double premium beef patties", "Caramelized mushrooms", "Flame-roasted onions", "Flame-roasted peppers", "Signature Royale fries", "Classic ketchup", "Creamy mayonnaise", "American-Swiss cheese", "Artisan bun"],
    allergens: ["Contains Gluten", "Contains Dairy"]
  }
];

export const fryFlavors: FryFlavor[] = [
  {
    id: "herb-garlic",
    name: "Herb & Garlic",
    description: "Fresh herbs + parmesan",
    icon: "🌿",
    category: "GOURMET",
    image: "/images/Herb & Garlic Fresh herbs.png"
  },
  {
    id: "sea-salt-pepper",
    name: "Sea Salt & Pepper",
    description: "Simple + sophisticated",
    icon: "🧂",
    category: "CLASSIC",
    image: ""
  },
  {
    id: "cajun",
    name: "Cajun",
    description: "Spicy kick + bold flavor",
    icon: "🌶️",
    category: "SPICY",
    image: ""
  },
  {
    id: "smokey-bbq",
    name: "Smokey BBQ",
    description: "Sweet + smoky perfection",
    icon: "🔥",
    category: "SWEET",
    image: "/images/fries_seasoned_optimized.jpg"
  }
];

export const royaleBites: MenuItem[] = [
  {
    id: "nacho-cheese-ravioli",
    name: "Nacho Cheese Ravioli",
    description: "Handmade Doritos Ravioli, deep-fried to perfection, stuffed with jalapeño nacho cheese. Served with 'New World' roasted tomato sauce",
    price: 7.50,
    image: "/images/nacho_cheese_ravioli_optimized.jpg",
    category: "royale-bites",
    tags: ["SIGNATURE"]
  },
  {
    id: "soft-pretzels",
    name: "Soft Pretzels",
    description: "Trio of freshly baked soft pretzels, perfect for dipping into our rich, creamy cheese fondue. A comforting classic, perfect for sharing",
    price: 7.50,
    image: "/images/soft_pretzels_optimized.jpg",
    category: "royale-bites"
  },
  {
    id: "fried-mac-cheese",
    name: "Fried Mac & Cheese",
    description: "House-made macaroni and cheese, fried until crispy and golden. Served with a drizzle of cheese fondue and our signature Royale sauce",
    price: 7.00,
    image: "/images/fried_mac_cheese_optimized.jpg",
    category: "royale-bites"
  },
  {
    id: "royale-fries-brisket",
    name: "Royale Fries And Brisket",
    description: "Savory meats sweet! Royale fries and 18-hour smoked brisket, topped with smoked Gouda cheese fondue, creamy coleslaw, honey-ancho BBQ sauce",
    price: 15.00,
    image: "/images/royale_fries_brisket_optimized.jpg",
    category: "royale-bites",
    tags: ["FEAST"]
  }
];

export const chickenSandwiches: MenuItem[] = [
  {
    id: "vincent-vega",
    name: "Vincent Vega",
    description: "Crispy, classic, irresistible. Our Cuban fried chicken comes with Nablus pickles, artisan romaine, Cajun aioli, and a blend of American-Swiss cheese, crafted to satisfy all your cravings.",
    price: 12.00,
    image: "/images/vincent_vega_classic_fried_chicken_optimized.jpg",
    category: "chicken-sandwiches",
    tags: ["CLASSIC"]
  },
  {
    id: "marsellus-wallace",
    name: "Marsellus Wallace",
    description: "For those who like it sweet and spicy. This sandwich features Cuban fried chicken topped with Nablus pickles, mayo, a fried egg, roasted jalapeño, and sweet chili butter, offering a unique flavor explosion.",
    price: 13.00,
    image: "/images/marsellus_wallace_sweet_spicy_chicken_optimized.jpg",
    category: "chicken-sandwiches",
    tags: ["SWEET & SPICY"]
  }
];

export const salads: MenuItem[] = [
  {
    id: "caesar",
    name: "Caesar",
    description: "Dive into crisp textures and robust flavors! Artisan romaine lettuce, Arcadian harvest mix, shaved Parmesan Reggiano. Each leaf lightly dressed with our creamy Caesar dressing and topped with petite za'atar croutons for a Mediterranean twist.",
    price: 12.00,
    image: "/images/caesar_salad_optimized.jpg",
    category: "salads",
    tags: ["FRESH"],
    allergens: ["Contains Dairy", "Contains Gluten"],
    ingredients: ["Romaine lettuce", "Arcadian harvest mix", "Parmesan Reggiano", "za'atar croutons", "Caesar dressing (anchovy-based)"],
    addOns: [
      { id: "grilled-chicken", name: "Free-Range Grilled Chicken Breast", price: 4.00 },
      { id: "avocado", name: "Avocado", price: 2.50 }
    ]
  },
  {
    id: "fairway",
    name: "Fairway",
    description: "Fresh as a morning on the fairway! Arcadian harvest mix tossed with feta cheese, shredded carrots and cabbage, juicy tomatoes, crisp cucumbers. Garnished with candied praline pecans for a touch of sweetness, all dressed in our house-made Fairway dressing.",
    price: 12.00,
    image: "/images/fairway_salad_optimized.jpg",
    category: "salads",
    tags: ["GOURMET"],
    allergens: ["Contains Dairy", "Contains Nuts"],
    ingredients: ["Arcadian harvest mix", "feta cheese", "carrots", "cabbage", "tomatoes", "cucumbers", "candied praline pecans", "Fairway dressing"],
    addOns: [
      { id: "grilled-chicken", name: "Free-Range Grilled Chicken Breast", price: 4.00 },
      { id: "avocado", name: "Avocado", price: 2.50 }
    ]
  }
];

export const shakes: ShakeItem[] = [
  {
    id: "vanilla-bean",
    name: "Vanilla Bean",
    description: "Real vanilla beans • Smooth & creamy",
    price: 5.50,
    category: "classic",
    icon: "💡",
    image: ""
  },
  {
    id: "strawberry-nesquik",
    name: "Strawberry Nesquik",
    description: "Sweet berry bliss • Childhood favorite",
    price: 6.50,
    category: "nostalgic",
    icon: "🍓",
    image: "/images/capn_crunch_shake_optimized.jpg"
  },
  {
    id: "fruity-pebbles",
    name: "Fruity Pebbles",
    description: "Fruity cereal crunch",
    price: 6.50,
    category: "colorful",
    icon: "🌈",
    image: "/images/cinnamon_shake_optimized.jpg"
  },
  {
    id: "cinnamon-toast-crunch",
    name: "Cinnamon Toast Crunch",
    description: "Sweet cinnamon spice",
    price: 6.50,
    category: "warm",
    icon: "🍞",
    image: "/images/fruity_shake_optimized.jpg"
  },
  {
    id: "capn-crunch-berries",
    name: "Cap'n Crunch Berries",
    description: "Crunchy berry flavor",
    price: 6.50,
    category: "berry",
    icon: "🫐",
    image: ""
  },
  {
    id: "chocolate-nesquick",
    name: "Chocolate Nesquick",
    description: "Deep cocoa flavors • Smooth & decadent",
    price: 6.50,
    category: "rich",
    icon: "🍫",
    image: ""
  },
  {
    id: "cookie-butter-nutella",
    name: "Cookie Butter & Nutella",
    description: "Ultimate dessert experience • Absolutely irresistible",
    price: 6.50,
    category: "indulgent",
    icon: "🍪",
    image: ""
  },
  {
    id: "shake-collection-cta",
    name: "All Flavors Available",
    description: "Visit us to explore our complete shake collection • Made fresh daily",
    price: 0,
    category: "cta",
    icon: "🍦",
    image: "/images/collection-shakes-small.png"
  }
];

export const menuCategories: Category[] = [
  {
    id: "signature-burgers",
    name: "Signature Burgers",
    description: "Each burger is crafted with premium ingredients and served with AI-optimized precision",
    items: signatureBurgers
  },
  {
    id: "royale-bites",
    name: "Royale Bites",
    items: royaleBites
  },
  {
    id: "chicken-sandwiches",
    name: "Between Bread - Los Pollos Hermanos (The Chicken Brothers)",
    description: "Crispy, classic, irresistible chicken sandwiches with unique flavor profiles",
    items: chickenSandwiches
  },
  {
    id: "salads",
    name: "Royale Greens",
    description: "Our salad options are crafted with the same creativity and commitment to quality as our signature burgers and sides. Our 'Greens' menu features fresh, vibrant ingredients that come together in flavorful harmony, offering a lighter yet equally satisfying dining option.",
    items: salads
  }
]; 